export enum FeatureKeys {
  Activities = 'activities',
  AdminPage = 'admin_page',
  AgenticSearch = 'agentic_search',
  AskOwlBeta = 'ask_owl_beta',
  AudioEnabled = 'audio_enabled',
  ConversationalSearch = 'conversational_search',
  CustomerTerminology = 'customer_terminology',
  DeepSearch = 'deep_search',
  DeleteFiles = 'delete_files',
  EditInPlace = 'edit_in_place',
  FileScopeFilter = 'file_scope_filter',
  FilesUploadDocx = 'files_upload_docx',
  FilesUploadHtml = 'files_upload_html',
  FilesUploadRtf = 'files_upload_rtf',
  GenerateSummary = 'generate_summary',
  GenerateTemplate = 'generate_template',
  Insights = 'insights',
  MultiParticipantClaims = 'multi_participant_claims',
  OwlShell = 'owl_shell',
  PreviewTemplates = 'preview_templates',
  SelfServiceView = 'self_service_view',
  ShellSidebar = 'shell_sidebar',
  ShowExtractionDebug = 'show_extraction_debug',
  SSOEnabled = 'sso_enabled',
  StructuredActivities = 'structured_activities',
  SummaryTemplates = 'summary_templates',
}
